<input class="form-control" type="number" inputmode="numeric" [(ngModel)]="numberValue" />